/* eslint-disable react/jsx-props-no-spreading */
import React, { FC } from 'react';
import SizedBox, { SizedBoxProps } from './SizedBox';

export interface FlexItemProps extends SizedBoxProps {
  flex?: number;
}

const FlexItem: FC<FlexItemProps> = ({
  children, flex = 1, ...rest
}) => (
  <SizedBox
    {...rest}
    flex={flex}
    minWidth="0"
  >
    {children}
  </SizedBox>
);

export default FlexItem;
